import React, { useState } from "react";
import { History, Loader2, CheckCircle2, XCircle, ShieldAlert } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";

const VERDICTS = {
  AVAILABLE: {
    icon: CheckCircle2, cls: "bg-[#E8F2EC] border-[#A8C9B6] text-[#1F4E3D]",
    title: "Historique disponible",
    text: "Nayax renvoie des ventes anciennes : un import de 2025 et début 2026 est envisageable.",
  },
  UNAVAILABLE: {
    icon: XCircle, cls: "bg-[#FCEEEA] border-[#E8B4A6] text-[#A04E2C]",
    title: "Historique indisponible",
    text: "Nayax ne renvoie aucune vente ancienne par cet accès. Les rapports historiques restent à tirer depuis le portail Nayax.",
  },
  NO_PERMISSION: {
    icon: ShieldAlert, cls: "bg-[#FFF6E5] border-[#E8CF9A] text-[#8A5A00]",
    title: "Accès refusé par Nayax",
    text: "La clé API Nayax n'a pas le droit de lire les rapports (« Insufficient permissions »). Nayax peut activer ce droit sur votre clé ; le test pourra alors être relancé.",
  },
};

export default function NayaxHistoryProbe() {
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);

  const run = async () => {
    setBusy(true); setError(null);
    try {
      const { data } = await api.post("/nayax/history-probe", {}, { timeout: 150000 });
      setReport(data);
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  const v = report && VERDICTS[report.verdict];
  const Icon = v?.icon;
  return (
    <div className="bg-white border border-[#E5E5E0] rounded-xl p-4 space-y-3" data-testid="nayax-history-probe">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-medium text-[#1A1C1A] flex items-center gap-2"><History className="w-4 h-4" /> Historique des ventes Nayax</div>
          <div className="text-xs text-[#575A57]">Vérifie si Nayax fournit les ventes de 2025 et début 2026. Lecture seule, rien n&apos;est modifié.</div>
        </div>
        <Button onClick={run} disabled={busy} className="bg-[#1F4E3D] hover:bg-[#173B2E]" data-testid="nayax-history-probe-btn">
          {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />} Tester l&apos;historique Nayax
        </Button>
      </div>
      {busy && <div className="text-xs text-[#575A57]">Interrogation de Nayax… (jusqu&apos;à 1-2 minutes)</div>}
      {error && <div className="text-sm text-[#C05C47]" data-testid="nayax-history-probe-error">{error}</div>}
      {v && (
        <div className={`border rounded-lg p-3 ${v.cls}`} data-testid="nayax-history-probe-verdict">
          <div className="font-semibold flex items-center gap-2"><Icon className="w-4 h-4" /> {v.title}</div>
          <div className="text-sm mt-1">{v.text}</div>
          {report.verdict === "AVAILABLE" && (
            <div className="text-sm mt-2" data-testid="nayax-history-probe-riddes">
              {report.machine?.name || "Riddes"} — janvier 2026 :{" "}
              <strong>{report.riddes_jan_2026_total != null ? `CHF ${report.riddes_jan_2026_total}` : "montant non identifié"}</strong>
              {" "}(portail Nayax : CHF 740.60)
            </div>
          )}
          <div className="text-[11px] mt-2 opacity-70">Résultat détaillé enregistré pour analyse.</div>
        </div>
      )}
    </div>
  );
}
